import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import ShowIcon from '@interxfi/design-system/icons/react/icon-show';
import { PageTabRail } from '../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../../components/router/router-tabbed-navigation';
import { DocgenPreviewTradeConfirmDrawer } from '../../../../../../../../../../../features/generate/trade-confirmation/docgen-preview-trade-confirm-drawer';
import { DocgenTradeConfirmTasksTable } from '../../../../../../../../../../../features/generate/trade-confirmation/task/docgen-trade-confirm-tasks-table';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../../../../../../util/view-context';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/trade-confirmation/task/_task/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsDocGenTradeConfirm,
      label: 'Tasks',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsDocGenTradeConfirm>,
  head: () => getPageHead('Trade Confirmation Tasks'),
  component: DocgenTradeConfirmTaskList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <DocgenPreviewTradeConfirmDrawer
              trigger={<Button affixIcon={<ShowIcon aria-hidden />} aria-label="Preview" size="small" variant="primary" />}
            />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsDocGenTradeConfirm}
    />
  );
}

function DocgenTradeConfirmTaskList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <DocgenTradeConfirmTasksTable HeaderActions={TableHeader} view={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
